// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  renderStatic: false,
  name: 'GOD Tv',
  siteID: 26,
  isWooHoo: false,
  singleChannel: false,
  isHeadStart: false,
  singleChannelMultiPlay: true,
  analytics: 'UA-156838877-11',
  link: 'https%3A%2F%2Fgod-tv.mobi/',
  terms: 'https://campaign.videyo.tv/terms-and-conditions/vg/Terms+%26+Conditions+-+Videyo.pdf',
  doi: 'http://optin.telkomsdp.co.za/service/59?cid=500022',
  unencodeLink: 'https://god-tv.mobi',
  isMTN: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
